function brandFilterActions(target) {
  if (!this.$data.settings.filtersLocked) {
    this.setFilterVisibility('showBrandFilter');
    this.scrollToFilterSmallScreen(target);
  }
}
export default brandFilterActions;
